/**
 * Countries lookup for registration form
 * Contains all 192 countries with English and Arabic translations
 * Code is the English name in lowercase (used as value sent to backend)
 */

export interface Country {
  code: string;  // English name in lowercase (e.g., "saudi arabia", "egypt")
  en: string;    // English name
  ar: string;    // Arabic name
}

export const COUNTRIES: Country[] = [
  { code: "afghanistan", en: "Afghanistan", ar: "أفغانستان" },
  { code: "albania", en: "Albania", ar: "ألبانيا" },
  { code: "algeria", en: "Algeria", ar: "الجزائر" },
  { code: "andorra", en: "Andorra", ar: "أندورا" },
  { code: "angola", en: "Angola", ar: "أنغولا" },
  { code: "antigua and barbuda", en: "Antigua and Barbuda", ar: "أنتيغوا وبربودا" },
  { code: "argentina", en: "Argentina", ar: "الأرجنتين" },
  { code: "armenia", en: "Armenia", ar: "أرمينيا" },
  { code: "australia", en: "Australia", ar: "أستراليا" },
  { code: "austria", en: "Austria", ar: "النمسا" },
  { code: "azerbaijan", en: "Azerbaijan", ar: "أذربيجان" },
  { code: "bahamas", en: "Bahamas", ar: "جزر البهاما" },
  { code: "bahrain", en: "Bahrain", ar: "البحرين" },
  { code: "bangladesh", en: "Bangladesh", ar: "بنغلاديش" },
  { code: "barbados", en: "Barbados", ar: "بربادوس" },
  { code: "belarus", en: "Belarus", ar: "بيلاروسيا" },
  { code: "belgium", en: "Belgium", ar: "بلجيكا" },
  { code: "belize", en: "Belize", ar: "بليز" },
  { code: "benin", en: "Benin", ar: "بنين" },
  { code: "bhutan", en: "Bhutan", ar: "بوتان" },
  { code: "bolivia", en: "Bolivia", ar: "بوليفيا" },
  { code: "bosnia and herzegovina", en: "Bosnia and Herzegovina", ar: "البوسنة والهرسك" },
  { code: "botswana", en: "Botswana", ar: "بوتسوانا" },
  { code: "brazil", en: "Brazil", ar: "البرازيل" },
  { code: "brunei", en: "Brunei", ar: "بروناي" },
  { code: "bulgaria", en: "Bulgaria", ar: "بلغاريا" },
  { code: "burkina faso", en: "Burkina Faso", ar: "بوركينا فاسو" },
  { code: "burundi", en: "Burundi", ar: "بوروندي" },
  { code: "cambodia", en: "Cambodia", ar: "كمبوديا" },
  { code: "cameroon", en: "Cameroon", ar: "الكاميرون" },
  { code: "canada", en: "Canada", ar: "كندا" },
  { code: "cape verde", en: "Cape Verde", ar: "الرأس الأخضر" },
  { code: "central african republic", en: "Central African Republic", ar: "جمهورية أفريقيا الوسطى" },
  { code: "chad", en: "Chad", ar: "تشاد" },
  { code: "chile", en: "Chile", ar: "تشيلي" },
  { code: "china", en: "China", ar: "الصين" },
  { code: "colombia", en: "Colombia", ar: "كولومبيا" },
  { code: "comoros", en: "Comoros", ar: "جزر القمر" },
  { code: "congo", en: "Congo", ar: "الكونغو" },
  { code: "costa rica", en: "Costa Rica", ar: "كوستاريكا" },
  { code: "croatia", en: "Croatia", ar: "كرواتيا" },
  { code: "cuba", en: "Cuba", ar: "كوبا" },
  { code: "cyprus", en: "Cyprus", ar: "قبرص" },
  { code: "czech republic", en: "Czech Republic", ar: "التشيك" },
  { code: "denmark", en: "Denmark", ar: "الدنمارك" },
  { code: "djibouti", en: "Djibouti", ar: "جيبوتي" },
  { code: "dominica", en: "Dominica", ar: "دومينيكا" },
  { code: "dominican republic", en: "Dominican Republic", ar: "جمهورية الدومينيكان" },
  { code: "east timor", en: "East Timor", ar: "تيمور الشرقية" },
  { code: "ecuador", en: "Ecuador", ar: "الإكوادور" },
  { code: "egypt", en: "Egypt", ar: "مصر" },
  { code: "el salvador", en: "El Salvador", ar: "السلفادور" },
  { code: "equatorial guinea", en: "Equatorial Guinea", ar: "غينيا الاستوائية" },
  { code: "eritrea", en: "Eritrea", ar: "إريتريا" },
  { code: "estonia", en: "Estonia", ar: "إستونيا" },
  { code: "eswatini", en: "Eswatini", ar: "إسواتيني" },
  { code: "ethiopia", en: "Ethiopia", ar: "إثيوبيا" },
  { code: "fiji", en: "Fiji", ar: "فيجي" },
  { code: "finland", en: "Finland", ar: "فنلندا" },
  { code: "france", en: "France", ar: "فرنسا" },
  { code: "gabon", en: "Gabon", ar: "الغابون" },
  { code: "gambia", en: "Gambia", ar: "غامبيا" },
  { code: "georgia", en: "Georgia", ar: "جورجيا" },
  { code: "germany", en: "Germany", ar: "ألمانيا" },
  { code: "ghana", en: "Ghana", ar: "غانا" },
  { code: "greece", en: "Greece", ar: "اليونان" },
  { code: "grenada", en: "Grenada", ar: "غرينادا" },
  { code: "guatemala", en: "Guatemala", ar: "غواتيمالا" },
  { code: "guinea", en: "Guinea", ar: "غينيا" },
  { code: "guinea-bissau", en: "Guinea-Bissau", ar: "غينيا بيساو" },
  { code: "guyana", en: "Guyana", ar: "غيانا" },
  { code: "haiti", en: "Haiti", ar: "هايتي" },
  { code: "honduras", en: "Honduras", ar: "هندوراس" },
  { code: "hungary", en: "Hungary", ar: "المجر" },
  { code: "iceland", en: "Iceland", ar: "آيسلندا" },
  { code: "india", en: "India", ar: "الهند" },
  { code: "indonesia", en: "Indonesia", ar: "إندونيسيا" },
  { code: "iran", en: "Iran", ar: "إيران" },
  { code: "iraq", en: "Iraq", ar: "العراق" },
  { code: "ireland", en: "Ireland", ar: "أيرلندا" },
  { code: "italy", en: "Italy", ar: "إيطاليا" },
  { code: "jamaica", en: "Jamaica", ar: "جامايكا" },
  { code: "japan", en: "Japan", ar: "اليابان" },
  { code: "jordan", en: "Jordan", ar: "الأردن" },
  { code: "kazakhstan", en: "Kazakhstan", ar: "كازاخستان" },
  { code: "kenya", en: "Kenya", ar: "كينيا" },
  { code: "kiribati", en: "Kiribati", ar: "كيريباتي" },
  { code: "kuwait", en: "Kuwait", ar: "الكويت" },
  { code: "kyrgyzstan", en: "Kyrgyzstan", ar: "قيرغيزستان" },
  { code: "laos", en: "Laos", ar: "لاوس" },
  { code: "latvia", en: "Latvia", ar: "لاتفيا" },
  { code: "lebanon", en: "Lebanon", ar: "لبنان" },
  { code: "lesotho", en: "Lesotho", ar: "ليسوتو" },
  { code: "liberia", en: "Liberia", ar: "ليبيريا" },
  { code: "libya", en: "Libya", ar: "ليبيا" },
  { code: "liechtenstein", en: "Liechtenstein", ar: "ليختنشتاين" },
  { code: "lithuania", en: "Lithuania", ar: "ليتوانيا" },
  { code: "luxembourg", en: "Luxembourg", ar: "لوكسمبورغ" },
  { code: "madagascar", en: "Madagascar", ar: "مدغشقر" },
  { code: "malawi", en: "Malawi", ar: "ملاوي" },
  { code: "malaysia", en: "Malaysia", ar: "ماليزيا" },
  { code: "maldives", en: "Maldives", ar: "جزر المالديف" },
  { code: "mali", en: "Mali", ar: "مالي" },
  { code: "malta", en: "Malta", ar: "مالطا" },
  { code: "marshall islands", en: "Marshall Islands", ar: "جزر مارشال" },
  { code: "mauritania", en: "Mauritania", ar: "موريتانيا" },
  { code: "mauritius", en: "Mauritius", ar: "موريشيوس" },
  { code: "mexico", en: "Mexico", ar: "المكسيك" },
  { code: "micronesia", en: "Micronesia", ar: "ميكرونيزيا" },
  { code: "moldova", en: "Moldova", ar: "مولدوفا" },
  { code: "monaco", en: "Monaco", ar: "موناكو" },
  { code: "mongolia", en: "Mongolia", ar: "منغوليا" },
  { code: "montenegro", en: "Montenegro", ar: "الجبل الأسود" },
  { code: "morocco", en: "Morocco", ar: "المغرب" },
  { code: "mozambique", en: "Mozambique", ar: "موزمبيق" },
  { code: "myanmar", en: "Myanmar", ar: "ميانمار" },
  { code: "namibia", en: "Namibia", ar: "ناميبيا" },
  { code: "nauru", en: "Nauru", ar: "ناورو" },
  { code: "nepal", en: "Nepal", ar: "نيبال" },
  { code: "netherlands", en: "Netherlands", ar: "هولندا" },
  { code: "new zealand", en: "New Zealand", ar: "نيوزيلندا" },
  { code: "nicaragua", en: "Nicaragua", ar: "نيكاراغوا" },
  { code: "niger", en: "Niger", ar: "النيجر" },
  { code: "nigeria", en: "Nigeria", ar: "نيجيريا" },
  { code: "north korea", en: "North Korea", ar: "كوريا الشمالية" },
  { code: "north macedonia", en: "North Macedonia", ar: "مقدونيا الشمالية" },
  { code: "norway", en: "Norway", ar: "النرويج" },
  { code: "oman", en: "Oman", ar: "عُمان" },
  { code: "pakistan", en: "Pakistan", ar: "باكستان" },
  { code: "palau", en: "Palau", ar: "بالاو" },
  { code: "palestine", en: "Palestine", ar: "فلسطين" },
  { code: "panama", en: "Panama", ar: "بنما" },
  { code: "papua new guinea", en: "Papua New Guinea", ar: "بابوا غينيا الجديدة" },
  { code: "paraguay", en: "Paraguay", ar: "باراغواي" },
  { code: "peru", en: "Peru", ar: "بيرو" },
  { code: "philippines", en: "Philippines", ar: "الفلبين" },
  { code: "poland", en: "Poland", ar: "بولندا" },
  { code: "portugal", en: "Portugal", ar: "البرتغال" },
  { code: "qatar", en: "Qatar", ar: "قطر" },
  { code: "romania", en: "Romania", ar: "رومانيا" },
  { code: "russia", en: "Russia", ar: "روسيا" },
  { code: "rwanda", en: "Rwanda", ar: "رواندا" },
  { code: "saint kitts and nevis", en: "Saint Kitts and Nevis", ar: "سانت كيتس ونيفيس" },
  { code: "saint lucia", en: "Saint Lucia", ar: "سانت لوسيا" },
  { code: "saint vincent and the grenadines", en: "Saint Vincent and the Grenadines", ar: "سانت فنسنت والغرينادين" },
  { code: "samoa", en: "Samoa", ar: "ساموا" },
  { code: "san marino", en: "San Marino", ar: "سان مارينو" },
  { code: "são tomé and príncipe", en: "São Tomé and Príncipe", ar: "ساو تومي وبرينسيب" },
  { code: "saudi arabia", en: "Saudi Arabia", ar: "المملكة العربية السعودية" },
  { code: "senegal", en: "Senegal", ar: "السنغال" },
  { code: "serbia", en: "Serbia", ar: "صربيا" },
  { code: "seychelles", en: "Seychelles", ar: "سيشل" },
  { code: "sierra leone", en: "Sierra Leone", ar: "سيراليون" },
  { code: "singapore", en: "Singapore", ar: "سنغافورة" },
  { code: "slovakia", en: "Slovakia", ar: "سلوفاكيا" },
  { code: "slovenia", en: "Slovenia", ar: "سلوفينيا" },
  { code: "solomon islands", en: "Solomon Islands", ar: "جزر سليمان" },
  { code: "somalia", en: "Somalia", ar: "الصومال" },
  { code: "south africa", en: "South Africa", ar: "جنوب أفريقيا" },
  { code: "south sudan", en: "South Sudan", ar: "جنوب السودان" },
  { code: "spain", en: "Spain", ar: "إسبانيا" },
  { code: "sri lanka", en: "Sri Lanka", ar: "سريلانكا" },
  { code: "sudan", en: "Sudan", ar: "السودان" },
  { code: "suriname", en: "Suriname", ar: "سورينام" },
  { code: "sweden", en: "Sweden", ar: "السويد" },
  { code: "switzerland", en: "Switzerland", ar: "سويسرا" },
  { code: "syria", en: "Syria", ar: "سوريا" },
  { code: "tajikistan", en: "Tajikistan", ar: "طاجيكستان" },
  { code: "tanzania", en: "Tanzania", ar: "تنزانيا" },
  { code: "thailand", en: "Thailand", ar: "تايلاند" },
  { code: "togo", en: "Togo", ar: "توغو" },
  { code: "tonga", en: "Tonga", ar: "تونغا" },
  { code: "trinidad and tobago", en: "Trinidad and Tobago", ar: "ترينيداد وتوباغو" },
  { code: "tunisia", en: "Tunisia", ar: "تونس" },
  { code: "turkey", en: "Turkey", ar: "تركيا" },
  { code: "turkmenistan", en: "Turkmenistan", ar: "تركمانستان" },
  { code: "tuvalu", en: "Tuvalu", ar: "توفالو" },
  { code: "uganda", en: "Uganda", ar: "أوغندا" },
  { code: "ukraine", en: "Ukraine", ar: "أوكرانيا" },
  { code: "united arab emirates", en: "United Arab Emirates", ar: "الإمارات العربية المتحدة" },
  { code: "united kingdom", en: "United Kingdom", ar: "المملكة المتحدة" },
  { code: "united states", en: "United States", ar: "الولايات المتحدة" },
  { code: "uruguay", en: "Uruguay", ar: "أوروغواي" },
  { code: "uzbekistan", en: "Uzbekistan", ar: "أوزبكستان" },
  { code: "vanuatu", en: "Vanuatu", ar: "فانواتو" },
  { code: "vatican city", en: "Vatican City", ar: "مدينة الفاتيكان" },
  { code: "venezuela", en: "Venezuela", ar: "فنزويلا" },
  { code: "vietnam", en: "Vietnam", ar: "فيتنام" },
  { code: "yemen", en: "Yemen", ar: "اليمن" },
  { code: "zambia", en: "Zambia", ar: "زامبيا" },
  { code: "zimbabwe", en: "Zimbabwe", ar: "زيمبابوي" },
];

/**
 * Helper function to get country by code
 */
export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(c => c.code === code.toLowerCase());
};

/**
 * Helper function to get country display name by code
 */
export const getCountryName = (code: string, language: 'en' | 'ar' = 'en'): string => {
  const country = getCountryByCode(code);
  if (!country) return code;
  return language === 'ar' ? country.ar : country.en;
};
